import { useEffect, useRef, useState } from "react";
import { fetchRelatedProducts } from "../lib/storefront";
import type { PocaConfig, Product } from "../types";

type State = {
  products: Product[];
  loading: boolean;
};

/**
 * 상세 페이지의 "Recommended for you" 목록.
 * 현재 상품의 멤버/그룹/앨범 태그와 겹치는 같은 vendor(PC)·판매중 상품을 조회한다.
 * handle 이 바뀌면(추천 카드 클릭 등) 자동으로 다시 불러온다.
 */
export function useRelatedProducts(
  config: PocaConfig,
  handle: string | null,
  tags: string[],
  limit = 10
) {
  const [state, setState] = useState<State>({ products: [], loading: false });
  const tagsKey = tags.join("|");
  const abortRef = useRef<AbortController | null>(null);

  useEffect(() => {
    const baseTags = tagsKey ? tagsKey.split("|") : [];
    if (!handle || baseTags.length === 0) {
      setState({ products: [], loading: false });
      return;
    }

    abortRef.current?.abort();
    const ac = new AbortController();
    abortRef.current = ac;

    setState({ products: [], loading: true });

    fetchRelatedProducts(config, { handle, tags: baseTags }, limit, ac.signal)
      .then((products) => {
        if (ac.signal.aborted) return;
        setState({ products, loading: false });
      })
      .catch((e) => {
        if (ac.signal.aborted) return;
        console.error("[poca] useRelatedProducts failed", e);
        setState({ products: [], loading: false });
      });

    return () => ac.abort();
  }, [config, handle, tagsKey, limit]);

  return state;
}
